import { defineStore } from 'pinia';

interface PageData {
    title: string;
    content: string;
    context: string;
}

export const usePageDataStore = defineStore('pageData', {
    state: (): { data: PageData | null; context: string | null } => ({
        data: null,
        context: null,
    }),
    actions: {
        setData(newData: PageData) {
            this.data = newData;
            this.context = newData?.context ?? '';
        },
    },
    getters: {
        getData: state => state.data,
    },
});
